import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Source from './icon-lead-created-goal.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'goalLeadCreated';

export const GoalLeadCreatedIcon = svgIconWrapper(SvgComponent);
